import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import Confetti, { ConfettiConfig } from 'react-dom-confetti';

const confetticonfig: ConfettiConfig = {
  angle: 90,
  spread: 360,
  startVelocity: 40,
  elementCount: 70,
  dragFriction: 0.12,
  duration: 3000,
  stagger: 3,
  width: '10px',
  height: '10px',
  // perspective: "500px",
  colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'],
};

export const Splash = () => {
  const [confetti, setConfetti] = useState<boolean>(false);
  useEffect(() => {
    setConfetti(true);
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ margin: 'auto', width: '1%' }}>
        <Confetti active={confetti} config={confetticonfig} />
      </Box>
      <h1>Welcome to Centerpiece!</h1>
      <br></br>Let us show you around....
    </Box>
  );
};
